import SectionTitle from './SectionTitle';

export { SectionTitle };
